import "../../../common/js/3rdparty/date.js";

import $ from "webpack-zepto";
window.$ = $;

import Ajax from "../../../common/js/Ajax.js";
import Navigation from "../../../common/js/Navigation.js";
import SelectableTableRow from "../../../common/js/SelectableTableRow.js";
import WidgetLoader from "../../../common/js/WidgetLoader.js";

import IssuesWidget from "./issue/IssuesWidget.js";
import IssueWidget from "./issue/IssueWidget.js";
import LoginWidget from "./auth/LoginWidget.js";
import LogoutWidget from "./auth/LogoutWidget.js";

$(() => {
	Ajax.initialize();
	Navigation.initialize();
	SelectableTableRow.initialize();

	WidgetLoader.add("IssuesWidget", IssuesWidget);
	WidgetLoader.add("IssueWidget", IssueWidget);
	WidgetLoader.add("LoginWidget", LoginWidget);
	WidgetLoader.add("LogoutWidget", LogoutWidget);

	WidgetLoader.initialize();

	LogoutWidget.updateNavigation();
});
